<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lX9yvU/tc-custom/9781035820023.jpg?1724089314213" alt="This image is the cover for the book The Satin Moth"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Satin Moth
      </h1>
      <p class="bookDescription body article font2">
        <p>This novel is a powerful, grim, historical fantasy story, based around the slave trade of the 17th and 18th centuries and its repercussions on a family whose wealth is built on it. The first part of the story introduces the present-day 10th Lord of Eastlyn, Robert Montague, and his family, who continue to endure the consequences of a voodoo hex placed upon them centuries before. The second part describes the 1st Lord of Eastlyn, George Montague, a wealthy but cruel and callous slave trader, and the enslavement of an Amazonian warrior named Nabila. Much of the novel’s strength is rooted in its foregrounding, which depicts man’s inhumanity to man and the vile and heinous nature of slavery. The final part shows the effect the curse has had on the Montague family and describes the actions and courage of young cousins who set out to free themselves from the voodoo hex placed upon them. The twists and turns that take place as a result are comprehensive and will provide entertaining relief for the reader following this tale of human suffering and vindication.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennie Dodd
      </h2>
      
      <p class="authorDescription body article">Jennie Dodd was raised in the picturesque market town of Shrewsbury, famous for its medieval castle, steep narrow streets, little alleyways, and timber framed buildings. Situated on the River Severn the town nestles in amongst the ancient Shropshire hills of the Stiperstones, the Long Mynd, Wenlock Edge and The Wrekin. Educated at the Wakeman Grammar School, Jennie developed a keen interest in art, history, and a love of English literature. Her novel reflects her appreciation of the works of J B Priestley and his socialist beliefs—that all men are born equal. The Satin Moth, as a result, explores themes connected to Britain’s bloody colonial past.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9a264516